/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoDisableTwoFactorAuthenticationInput = {
    clientMutationId?: string | null;
    username: string;
    workspace: string;
};
export type HomeContentDisableTwoFactorAuthMutationVariables = {
    input: infoDisableTwoFactorAuthenticationInput;
};
export type HomeContentDisableTwoFactorAuthMutationResponse = {
    readonly infoDisableTwoFactorAuthentication: {
        readonly clientMutationId: string | null;
    } | null;
};
export type HomeContentDisableTwoFactorAuthMutation = {
    readonly response: HomeContentDisableTwoFactorAuthMutationResponse;
    readonly variables: HomeContentDisableTwoFactorAuthMutationVariables;
};



/*
mutation HomeContentDisableTwoFactorAuthMutation(
  $input: infoDisableTwoFactorAuthenticationInput!
) {
  infoDisableTwoFactorAuthentication(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoDisableTwoFactorAuthenticationPayload",
    "kind": "LinkedField",
    "name": "infoDisableTwoFactorAuthentication",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeContentDisableTwoFactorAuthMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeContentDisableTwoFactorAuthMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "74bbdc1ce33cfad1fc8d9fae4d9c8596",
    "id": null,
    "metadata": {},
    "name": "HomeContentDisableTwoFactorAuthMutation",
    "operationKind": "mutation",
    "text": "mutation HomeContentDisableTwoFactorAuthMutation(\n  $input: infoDisableTwoFactorAuthenticationInput!\n) {\n  infoDisableTwoFactorAuthentication(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '39b4932de3aec9ef9e7dcc95e9b756df';
export default node;
